module.exports = __webpack_public_path__ + "img/744.7b51b596.jpg";